import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faMoon } from '@fortawesome/free-solid-svg-icons';
import NotificationDropdown from './NotificationDropdown';
import ProfileDropdown from './ProfileDropdown';
import AppContext from '../../context/Context';
import NineDotMenu from './NineDotMenu';
import SettingsToggle from '../../settings-panel/SettingsToggle';
import sun from '../../../../assets/img/icons/sun.svg';
import SupportDeskMessage from '../../supportDeskMessage';

function TopNavRightSideNavItem() {
  const {
    config: { isDark, isRTL },
    setConfig,
  } = useContext(AppContext);
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <SupportDeskMessage />
      <SettingsToggle />
      <Nav.Item as="li">
        <Nav.Link
          className="px-2 theme-control-toggle"
          onClick={() => setConfig('isDark', !isDark)}
        >
          <OverlayTrigger
            key="left"
            placement={isRTL ? 'bottom' : 'left'}
            overlay={(
              <Tooltip style={{ position: 'fixed' }} id="ThemeColor">
                {isDark ? 'Перемикнутсь на світлу тему' : 'Перемикнутсь на темну тему'}
              </Tooltip>
            )}
          >
            <div className="theme-control-toggle-label">
              {isDark ? (
                <img src={sun} alt="Перемикнутсь на світлу тему" />
              ) : (
                <FontAwesomeIcon
                  icon={faMoon}
                  className="fs-0"
                />
              )}

            </div>
          </OverlayTrigger>
        </Nav.Link>
      </Nav.Item>

      <NotificationDropdown />
      <NineDotMenu />
      <ProfileDropdown />
    </Nav>
  );
}

export default TopNavRightSideNavItem;
